export const setLayout = layout => ({
  type: 'LAYOUT/SET_LAYOUT',
  payload: layout,
})

export const toggleMenu = status => ({
  type: 'LAYOUT/TOGGLE_MENU',
  payload: status,
})



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Layout/Layout.actions.js